// Styles
import './footer.less';

function Footer() {
    return (
        <div className="footer">
            <p className="para">
                &copy; 2020. All rights reserved. Designed | <a href="mattjr.netlify.app" className="designer-link">Matthew Rungwe</a> 
            </p>
        </div>
    );
}

export default Footer;